import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CountryModel } from 'src/app/masters/country/country.model';
import { MasterService } from 'src/app/masters/master.service';
import { OrganismModel } from '../organisms/organism.model';
import * as CommonConstants from '../../utils/common.constants';
import { PharmacyService } from './pharmacy.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { AddPharmacyComponent } from './add-pharmacy/add-pharmacy.component';
import { PartnerSearchComponent } from '../partner-search/partner-search.component';
import { LoaderService } from 'src/app/common/loader.service';
import { SharedService } from 'src/app/utils/shared.service';

@Component({
  selector: 'app-pharmacy',
  templateUrl: './pharmacy.component.html',
  styleUrls: ['./pharmacy.component.scss']

})
export class PharmacyComponent implements OnInit {

  organisms: OrganismModel[];
  countries: CountryModel[];
  towns: any[];
  columnDefs: any[];
  startIndex;
  rowsPerPage;
  totalRecords;
  paginationSize = CommonConstants.PAGINATION_SIZE;
  pharmacySearchForm: FormGroup;
  rowData: any[];
  addPharmacy;
  toggleColumn = true;
  @ViewChild(PartnerSearchComponent,{static:true})   pSearch : PartnerSearchComponent;
  addressTypeList : any[];
  
  newPharmacy: AddPharmacyComponent;
  priv_addPharmacy: any;
  @ViewChild(AddPharmacyComponent, { static: true }) set Content(newPharmacyRef) {
    this.newPharmacy = newPharmacyRef;
  }

  constructor(public router: Router, private masterService: MasterService, private pharmacyService: PharmacyService
    , private formBuilder: FormBuilder, private loaderService: LoaderService,private sharedService:SharedService) {

    this.columnDefs = [
      // { headerName: 'Id', field: 'phamaId'},
      { headerName: 'Name', field: 'compaVaName'},
      { headerName: 'Organism', field: 'orgName'},
      { headerName: 'Work Phone', field: 'compaVaWorkPhone'},
      { headerName: 'Mobile Phone', field: 'compaVaMobilePhone1'},
      { headerName: 'Email', field: 'compaVaEmail'}
    ];

  }

  ngOnInit() {
    this.priv_addPharmacy=this.sharedService.hasPrivilege(CommonConstants.PRIV_ADD_PHARMACY);
    this.pSearch.pSearch["active"]=true;
    this.pSearch.partnerType=CommonConstants.PARTNER_PHARMACY_TYPE;
    this.loadMasterData();
    this.getFormGroup();
    this.search();
  }

  /**
    * Declare form group
    *  
    */
  private getFormGroup() {
    this.pharmacySearchForm = this.formBuilder.group({
      'orgsmId': new FormControl(),
      'compaVaName': new FormControl(),
      'cotryId': new FormControl(),
      'townId': new FormControl()

    })
  }

  loadMasterData() {
    this.masterService.getTown().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.towns = response['result'];
      }
    });

    this.masterService.getCountry().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.countries = response['result'];
      }
    });
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
    })
    this.masterService.getAddressTypes().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.addressTypeList = response['result'];
      }
    });
  }
  addNewPharmacy() {
    this.newPharmacy.addPharmacyTitle = true;
    this.newPharmacy.editPharmacyTitle = false;
    this.router.navigate(['addPharmacy']);
  }
  hideRightDiv() {
    this.addPharmacy = false;
    this.toggleColumn = true;
  }

  search() {
    this.startIndex = 0;
    this.rowsPerPage = CommonConstants.PAGINATION_SIZE;
    this.paginatedList();
    this.hideRightDiv();
    /* this.hospitalService.searchHospitals(this.hospitalSearch).subscribe(response => {
      console.log(response['result']);
      this.rowData = response['result'];
    }) */
  }

  paginatedList() {
    this.loaderService.display(true);
    this.pSearch.pSearch['partnerType'] = 3;
    this.pSearch.pSearch['active']=this.pSearch.pSearch['active'] ? 'A' :'I';
    this.pharmacyService.searchPharmacies(this.pSearch.pSearch, this.startIndex).subscribe(response => {
      this.loaderService.display(false);
      let result = response['result'];
      if (result) {
        result = result.map(item => ({
          ...item,
          orgName: item.orgsmId ? this.organisms.find(obj => obj.orgsmId === item.orgsmId).compaVaNameEn : null
        }))
      }
      this.rowData = result;
      this.totalRecords = result.length;
    },
    error => {
      this.loaderService.display(false);
    })
  }

  paginate(event: any) {
    this.startIndex = event.first;
    this.rowsPerPage = event.rows;
    this.paginatedList();
  }

  onRowClicked(event: any) {
    this.addPharmacy = true;
    this.toggleColumn = false;
    this.newPharmacy.addPharmacyTitle = false;
    this.newPharmacy.editPharmacyTitle = true;
    this.loadPharmacyById(event);
  }


  loadPharmacyById(event: any) {
    this.loaderService.display(true);
    this.pharmacyService.getPharmaciesById(event.data.phamaId).subscribe(response => {
      this.loaderService.display(false);
      this.newPharmacy.hospDepartment.departmentList = [];
      this.newPharmacy.hospAddress.addressList = [];
      if (response['code'] == 'S0000') {
        let result = response['result'][0];
        this.newPharmacy.pharmacyForm.patchValue({
          phamaId: result["phamaId"],
          compaNuNumberEmployees: result["compaNuNumberEmployees"],
          compaVaEmail: result["compaVaEmail"],
          compaVaMobilePhone1: result["compaVaMobilePhone1"],
          compaVaWorkPhone: result["compaVaWorkPhone"],
          compaVaMobilePhone2: result["compaVaMobilePhone2"],
          compaVaNameEn: result["compaVaNameEn"],
          compaVaWorkFax: result["compaVaWorkFax"],
          leforId: result["leforId"],
          orgsmId: result["orgsmId"],
          pacatId: result["pacatId"],
          pctypId: result["pctypId"],
          pagrpId: result["pagrpId"],
          natioId: result["natioId"],
          certiId: result["certiId"],
          paCatId: result["paCatId"],
          compaVaHomepage: result["compaVaHomepage"],
          agmntId:result["agmntId"],
          staRecCode: result["staRecCode"] ==='A' ? true : false
        });

        result['addressList'] = result.addressList.map(item => ({
          ...item,
          addressType: item.typeId ? this.addressTypeList.find(obj => +obj.typeId === +item.typeId).description : null,
          townName: item.townId ? this.towns.find(town => town.townId === item.townId).townDescEn : null,
          countryName: item.cotryId ? this.countries.find(country => country.cotryId === item.cotryId).cotryDescEn : null
        }));
        this.newPharmacy.hospDepartment.departmentList = JSON.parse(JSON.stringify(result['departmentList']));
        this.sharedService.setOrganismDepartment(this.newPharmacy.hospDepartment.departmentList);
        this.newPharmacy.hospAddress.addressList = JSON.parse(JSON.stringify(result['addressList']));
        this.newPharmacy.phoneNos.forEach(phone => {
          phone.phone=phone.getInternationPhoneFormat(result[phone.type]);
      })
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }
  reset() {
    this.pharmacySearchForm.reset();
    this.rowData =[];
    this.pSearch.pSearch={};
    this.hideRightDiv();
  }
}
